import { NgTemplateOutlet } from '@angular/common';
import { Component, Inject, inject, Optional, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { PREVIEW_TOKEN } from '../../../../constants/injectionTokens.constant';
import { BurgerMenuComponent } from '../../../../components/layout/burger-menu/burger-menu.component';
import { SideSectionNavigationComponent } from '../../../../components/layout/side-section-navigation/side-section-navigation.component';
import { FilterTextsPipe } from '../../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { ToFontSizePipe } from '../../../../pipes/to-font-size/to-font-size.pipe';
import { CorporateDesignService } from '../../../../services/corporate-design/corporate-design.service';
import {
  CONFIGURATION_SETTING_KEYS,
  EEntityType,
  EPaymentProviders,
  ERelationType,
} from '@web/dtos';
import { ConfigurationStore } from '../../../../services/api/configuration/configuration-store.service';
import { WebTextStore } from '../../../../services/api/text/web-text-store.service';
import { EConfigurationChannel } from '@web/dtos';
import { FellowTravelerStore } from '../../../../services/api/fellow-traveler/fellow-traveler-store.service';

@Component({
  selector: 'aw-account-page',
  imports: [
    LanguagePipe,
    ToFontSizePipe,
    ReactiveFormsModule,
    RouterOutlet,
    SideSectionNavigationComponent,
    FilterTextsPipe,
    BurgerMenuComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './account-page.component.html',
})
export class AccountPageComponent {
  protected readonly configurationStore: ConfigurationStore =
    inject(ConfigurationStore);
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly fellowTravelerStore = inject(FellowTravelerStore);
  protected readonly router: Router = inject(Router);
  @ViewChild(BurgerMenuComponent)
  protected readonly burgerMenu!: BurgerMenuComponent;

  constructor(
    @Optional() @Inject(PREVIEW_TOKEN) public readonly preview: boolean
  ) {}

  protected readonly RelationType: typeof ERelationType = ERelationType;
  protected readonly EPaymentProviders: typeof EPaymentProviders =
    EPaymentProviders;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly CONFIGURATION_SETTING_KEYS = CONFIGURATION_SETTING_KEYS;
  protected readonly EConfigurationChannel = EConfigurationChannel;
}
